<template>
  <div>
    <!-- Hamburger Button -->
    <button class="hamburger" @click="toggleMenu">☰</button>

    <!-- Slide-in Menu -->
    <div class="side-menu" :class="{ open: isOpen }">
      <button class="close-btn" @click="toggleMenu">✕</button>

      <router-link to="/" @click="closeMenu">Home</router-link>
      <router-link to="/band" @click="closeMenu">The Band</router-link>
      <router-link to="/discography" @click="closeMenu"
        >Discography</router-link
      >
      <router-link to="/news" @click="closeMenu">News</router-link>
      <router-link to="/media" @click="closeMenu">Media</router-link>
      <router-link to="/tour" @click="closeMenu">Tour</router-link>
      <router-link to="/fanZone" @click="closeMenu">Fan Zone</router-link>
      <router-link to="/contact" @click="closeMenu">Contact</router-link>
    </div>

    <div class="overlay" v-if="isOpen" @click="toggleMenu"></div>
  </div>
</template>

<script>
export default {
  name: 'HamburgerMenu',

  data() {
    return {
      isOpen: false,
    };
  },

  methods: {
    toggleMenu() {
      this.isOpen = !this.isOpen;
    },
    closeMenu() {
      this.isOpen = false;
    },
  },
};
</script>

<style scoped>
.hamburger {
  font-size: 2rem;
  color: white;
  background: transparent;
  border: none;
  cursor: pointer;
  z-index: 1001;
  position: fixed;
  top: 1.6rem;
  left: 1rem;
}

.side-menu {
  position: fixed;
  top: 0;
  left: -300px;
  width: 200px;
  height: 100dvh;
  background: #111;
  padding: 2.1rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  transition: left 0.3s ease;
  z-index: 1000;
  box-sizing: border-box;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.side-menu.open {
  left: 0;
}

.side-menu a {
  color: white;
  text-decoration: none;
  font-family: 'Cinzel Decorative', cursive;
  font-weight: 700;
  text-shadow: 2px 2px 5px rgba(36, 36, 36, 0.8);
}

.close-btn {
  align-self: flex-end;
  font-size: 2rem;
  background: transparent;
  color: white;
  border: none;
  cursor: pointer;
  margin-bottom: 1rem;
  line-height: 2rem;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  z-index: 999;
}
</style>
